export class StructureView {
  constructor(
    public readonly id: number,
    public readonly name: string,
    public readonly idProfil?: number,
  ) {}
}
